
import template from './AddEditTableField.html';
import FieldModel from '../../lib/models/FieldModel.js'

class AddEditTableFieldVM
{
	constructor(dialog)
	{
		this.dialog = dialog;
		this.edit = this.dialog.bindings.edit;
		this.save = ko_helper.safe_observable(this.dialog.bindings.save, true);
		this.types = ko.observableArray();
		this.type_config_inputs = ko.observable({});
		this.selected_type = ko.observable(null);

		let field_data = this.dialog.bindings.tableField || {};

		if (!this.edit)
		{
			let last_field_idx = this.dialog.bindings.last_field_idx || 0;
			field_data.idx = last_field_idx + 1;
		}

		this.field = ko.observable(new FieldModel(field_data));

		this.selected_type.subscribe((type) => {
			if (!type)
				return;

			const i = {};
			const options = this.field().options();

			for (const field of type.data?.ui_fields || [])
			{
				// Initialize an observable for each ui field, prefilled from current options if present
				let initialValue = null;
				if (options && Object.prototype.hasOwnProperty.call(options, field.name))
					initialValue = options[field.name];

				i[field.name] = ko.observable(initialValue);
			}

			this.type_config_inputs(i);
		});

		Grape.cache.get('FieldTypes').then((records) => {
			this.types(records);

			let current_type_name = this.field().options()?.type;
			if (current_type_name)
			{
				let matching_type = records.find(type => type.name === current_type_name);
				if (matching_type)
					this.selected_type(matching_type);
			}
		});
	}

	btnClose_click() {
		this.dialog.close();
	}

	async btnSave_click() {
		if (!this.selected_type())
		{
			Grape.alerts.alert({ type: 'warning', title: 'Error', message: 'Please select a field type.' });
			return;
		}

		if (!this.field().name())
		{
			Grape.alerts.alert({ type: 'warning', title: 'Error', message: 'Please enter a field name.' });
			return;
		}

		let field_type_options = {};
		for (let [k, v] of Object.entries(this.type_config_inputs()))
		{
			field_type_options[k] = v();
		}

		let other_options = {
			required: this.field().required(),
			multiple: this.field().multiple(),
			hidden: this.field().hidden(),
			tooltip: this.field().tooltip()
		};

		let normalized_type_options = {};
		for (let [key, value] of Object.entries(field_type_options))
		{
			let outVal = value;

			if (typeof outVal === 'object' && outVal !== null)
			{
				console.log('outVal is object', outVal);
				if (outVal.hasOwnProperty('name'))
					outVal = outVal.name;
				else if (outVal.hasOwnProperty('text'))
					outVal = outVal.text;
				else if (outVal.hasOwnProperty('value'))
					outVal = outVal.value;
			}

			normalized_type_options[key] = outVal;
		}

		this.field().options(Object.assign({ type: this.selected_type().name }, other_options, normalized_type_options));

		if (this.save() === false)
			this.dialog.close({ status: 'OK', tableField: this.field().serialize() });
		else
		{
			let res = await this.field().save();
			if (res)
			{
				if (res.status !== 'OK')
				{
					Grape.alerts.apiError(res);
					return;
				}

				Grape.alerts.alert({ type: 'success', title: 'Success', message: 'Successfully Saved.' });
				this.dialog.close(this.field());
			}
		}
	}
}

class AddEditTableFieldDialog
{
	constructor(bindings, element)
	{
		this.bindings = bindings || {};
		this.viewModel = new AddEditTableFieldVM(this); // Name of the ViewModel defined above
		this.name = 'AddEditTableField'; // Unique dialog name
	}
}

export default {
	name: 'AddEditTableField',
	dialog_class: AddEditTableFieldDialog,
	provider: 'ps',
	template: template
}
